// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M_UGj","scrollbars":"styles_scrollbars__h1k8o","slideInSearchBar":"styles_slideInSearchBar__wqOgn"};